// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__-823P","footer__copyright":"Footer_footer__copyright__h9IiW"};